/**
 * @desc getItemPerformance
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(params: API.walmart.test.getItemPerformance.Params, options?: any) {
  return updateResponse(
    http(URL + `/test/getItemPerformance`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
